import { styled } from '@linaria/react'

export const Wrapper = styled.div`
  padding: 0 !important;
  overflow: hidden;
`
export const CircleWrap = styled.div`
  width: 115vw;
  border-bottom-left-radius: 50%;
  border-bottom-right-radius: 50%;
  overflow: hidden;
  position: relative;
  left: 50%;
  transform: translateX(-50%);

  @media screen and (max-width: 992px) {
    width: 180vw;
  }
`

export const InnerWrap = styled.div`
  --text-color: var(--white);

  color: var(--text-color);
  background: var(--blue-gradient);
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 70vh;
  padding: 1.5rem 0;
  position: relative;
  overflow: hidden;
  width: 100vw;
  margin: 0 auto;
`

export const Image = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;

  #mouse-parallax-container {
    height: 100%;
    width: 100%;
  }

  .parallax-bg,
  .parallax-decor {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`

export const Decor = styled.img`
  position: absolute;
  z-index: 1;
  cursor: ${props => (props.isEditor ? 'move' : '')};
`

export const BGImage = styled.img`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 102% !important;
  height: 102% !important;
  object-fit: cover;
  object-position: top center;
`

export const Content = styled.div`
  width: 100%;
  max-width: var(--content-size);
  position: relative;
  z-index: 1;
  margin: auto 0;
  padding: 80px 0;

  @media screen and (max-width: 768px) {
    padding-bottom: 40px;
  }
`

export const Breadcrumbs = styled.ul`
  max-width: var(--wide-size);
  position: relative;
  z-index: 1;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem 1.5rem;
  font-size: var(--font-size-index);
  line-height: var(--line-height-index);
  font-weight: var(--font-weight-bold);
  letter-spacing: 1px;
  text-transform: uppercase;

  li {
    position: relative;

    &:last-child {
      a {
        color: var(--secondary);

        &:hover {
          color: var(--white);
        }
      }

       &::after {
        display: none;
       }
    }

    &::after {
      content: '>';
      position: absolute;
      top: 50%
      right: -0.75rem;
      transform: translate(50%, -50%);
      color: var(--white);
    }

    a {
      color: var(--white);
      text-decoration: none;

      &:hover {
        color: var(--secondary);
        opacity: 1;
      }
    }
  }
`

export const InnerBlocksContent = styled.div``
